export default "__VITE_ASSET__DxmPIFXv__"